import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import {  useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery } from '@mui/material';

// project-imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

import IconButton from 'components/@extended/IconButton';
import { DRAWER_WIDTH } from 'config';
import SIDEBAR from '../Drawer/sidebarStyles';

// assets
import { HambergerMenu } from 'iconsax-react';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // Shares the sidebar's dark-slate tokens so the header and sidebar read as one
  // continuous chrome band instead of two unrelated dark colors.
  const mainHeader = (
    <Toolbar sx={{ px: { xs: 2, sm: 4.5, lg: 8 }, bgcolor: SIDEBAR.bg }}>
      <IconButton
        aria-label="open drawer"
        onClick={handleDrawerToggle}
        edge="start"
        color="secondary"
        variant="light"
        size="large"
        sx={{ color: SIDEBAR.icon, bgcolor: SIDEBAR.hoverBg, ml: { xs: 0, lg: -2 }, p: 1, '&:hover': { color: SIDEBAR.textActive, bgcolor: SIDEBAR.hoverBg } }}
      >
        <HambergerMenu />
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    elevation: 0,
    sx: {
      bgcolor: SIDEBAR.bg,
      backdropFilter: 'blur(8px)',
      zIndex: 1200,
      width: open ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%'
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};

export default Header;
